<template>
  <b-form class="mt-3" @submit="onSubmitForm">
    <b-row>
      <b-col cols="12" md="6" v-if="props.mode === 'List'">
        <b-form-group label="ชื่อเจ้าหน้าที่ผู้รับเรื่อง" label-for="officer">
          <vue-select
            label="text"
            v-model="officer"
            :options="officers"
            @input="selectOnInput"
          />
        </b-form-group>
      </b-col>
      <!-- TEST DATE -->
      <!-- <b-col cols="12" md="3" >
              <InputFilter :filter="search[0]"/>
            </b-col>
            <b-col cols="12" md="3" >
              <InputFilter :filter="search[0]"/>
            </b-col> -->
      <!-- TEST DATE -->
      <!-- TEST TIME -->
      <!-- <b-col cols="12" md="3" >
              <InputFilter :filter="search[0]"/>
            </b-col>
            <b-col cols="12" md="3" >
              <InputFilter :filter="search[0]"/>
            </b-col> -->
      <!-- TEST TIME -->

      <b-col cols="12" md="6">
        <InputFilter :filter="search[0]" />
      </b-col>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[1]" />
      </b-col>

      <b-col v-if="props.mode == 'List'" cols="12" md="6">
        <InputFilter :filter="search[2]" />
      </b-col>
      <b-col v-if="props.mode == 'List'" cols="12" md="3">
        <InputFilter :filter="search[3]" />
      </b-col>
      <b-col v-if="props.mode == 'List'" cols="12" md="3">
        <InputFilter :filter="search[4]" />
      </b-col>

      <b-col v-if="props.mode == 'List'" cols="12" md="6">
        <InputFilter :filter="search[5]" />
      </b-col>
      <!-- TEST SELECT -->
    </b-row>
    <!-- Action Buttons -->
    <div class="text-center pt-1">
      <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        type="submit"
      >
        ค้นหา
      </b-button>
      <b-button
        variant="outline-secondary"
        type="reset"
        @click="onResetBtnClicked"
      >
        ล้าง
      </b-button>
    </div>
  </b-form>
</template>

<script>
import {
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BFormCheckbox,
} from "bootstrap-vue";
import VueSelect from "vue-select";
import InputFilter from "../../../filters/components/InputFilter.vue";

import * as storeMaster from "@/store/api/master/index.js";

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    VueSelect,
    InputFilter,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const options = [
      { text: "เลือกหน่วยงาน", value: null },
      { text: "หน่วยงาน1", value: "A5199950-2DB3-4FC5-0A35-08D9BEB37EF1" },
      { text: "หน่วยงาน1", value: "A5199950-2DB3-4FC5-0A35-08D9BEB37EF2" },
      { text: "หน่วยงาน1", value: "A5199950-2DB3-4FC5-0A35-08D9BEB37EF3" },
      { text: "หน่วยงาน1", value: "A5199950-2DB3-4FC5-0A35-08D9BEB37EF4" },
    ];

    const options2 = [
      { text: "ทั้งหมด", value: null },
      { text: "อยู่ระหว่างดำเนินการ", value: "1" },
      { text: "ส่งต่อเรื่อง", value: "2" },
      { text: "ผู้ร้องยุติเรื่อง", value: "3" },
      { text: "ยุติเรื่องในชั้นเจ้าหน้าที่", value: "4" },
      { text: "ยุติเรื่องในชั้นบังคับคดี", value: "5" },
    ];

    const officers = [{ text: "ชื่อเจ้าหน้าที่ผู้รับเรื่อง", value: "" }];

    const searchList = [
      {
        id: "receiveCode",
        label: "เลขรับแจ้ง / เลขสารบัญ / รหัสติดตามเรื่องหน่วยงานภายนอก",
        value: "",
        class: "",
        style: "",
        placeholder:
          "กรอกเลขรับแจ้ง / เลขสารบัญ / รหัสติดตามเรื่องหน่วยงานภายนอก",
        type: "text",
        options: [],
      },
      {
        id: "attorneySearch",
        label: "ข้อมูลผู้ร้องทุกข์ / ผู้มอบอำนาจ (ชื่อ-นามสกุล/เลขบัตรประชาชน)",
        value: "",
        class: "",
        style: "",
        placeholder: "กรอกข้อมูลผู้ร้องทุกข์ / ผู้มอบอำนาจ",
        type: "text",
        options: [],
      },
      {
        id: "companySearch",
        label:
          "ข้อมูลผู้ถูกร้องทุกข์ / ผู้ประกอบการ  (ชื่อผู้ประกอบการ / เลขนิติบุคคล)",
        value: "",
        class: "",
        style: "",
        placeholder:
          "กรอกข้อมูลผู้ถูกร้องทุกข์ / ผู้ประกอบการ  (ชื่อผู้ประกอบการ / เลขนิติบุคคล)",
        type: "text",
        options: [],
      },
      {
        id: "startdateSearch",
        label: "ช่วงเวลาที่ร้องทุกข์",
        value: "",
        class: "",
        style: "",
        placeholder: "จากวันที่",
        type: "date",
        options: [],
      },
      {
        id: "enddateSearch",
        label: "ถึง",
        value: "",
        class: "",
        style: "",
        placeholder: "ถึงวันที่",
        type: "date",
        options: [],
      },
      {
        id: "complainDetail",
        label: "รายละเอียดเรื่องร้องทุกข์",
        value: "",
        class: "",
        style: "",
        placeholder: "รายละเอียดเรื่องร้องทุกข์",
        type: "text",
        options: [],
      },
    ];
    const searchGroup = [
      {
        id: "receiveCode",
        label: "เลขรับแจ้ง / เลขสารบัญ / รหัสติดตามเรื่องหน่วยงานภายนอก",
        value: "",
        class: "",
        style: "",
        placeholder:
          "กรอกเลขรับแจ้ง / เลขสารบัญ / รหัสติดตามเรื่องหน่วยงานภายนอก",
        type: "text",
        options: [],
      },
      {
        id: "attorneySearch",
        label: "ข้อมูลผู้ร้องทุกข์ / ผู้มอบอำนาจ (ชื่อ-นามสกุล/เลขบัตรประชาชน)",
        value: "",
        class: "",
        style: "",
        placeholder: "กรอกข้อมูลผู้ร้องทุกข์ / ผู้มอบอำนาจ",
        type: "text",
        options: [],
      },
    ];
    return {
      options,
      search: props.mode == "List" ? searchList : searchGroup,
      props,
      officers,
      officer: { text: "ชื่อเจ้าหน้าที่ผู้รับเรื่อง", value: "" },
    };
  },
  mounted() {
    this.onSearchBtnClicked();
    this.getOfficer();
  },
  methods: {
    onSubmitForm(e) {
      e.preventDefault();
      this.onSearchBtnClicked();
    },
    onResetBtnClicked() {
      this.search.forEach(item => {
        item.value.forup = null;
      });
    },
    onSearchBtnClicked() {
      console.log("props.mode", this.props.mode);

      if (this.props.mode === "List") {
        const params = {
          code: this.search[0].value,
          name: this.search[1].value,
          company: this.search[2].value,
          startDate: this.search[3].value,
          endDate: this.search[4].value,
          value: this.search[5].value,

          userActive: this.officer !== null ? this.officer.value : "",
        };

        this.$emit("handleSubmit", params);
      } else {
        const params = {
          code: this.search[0].value,
          name: this.search[1].value,
        };

        this.$emit("handleSubmit", params);
      }
    },
    getOfficer() {
      const _this = this;

      storeMaster
        .getOfficerInfoAll()
        .then(function(response) {
          var setDataList = [];

          response.data.data.forEach((o) => {
            var setData = {};
            setData.value = o.user_id;
            setData.text = o.title_name + " " + o.fname + " " + o.lname;

            setDataList.push(setData);
          });

          const officerUnique = [
            ...new Map(
              setDataList.map((item) => [item["value"], item])
            ).values(),
          ];

          //_this.officers.push(...setDataList);
          _this.officers = officerUnique;

          _this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    selectOnInput() {
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
